var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"currentColor"}},[_c('path',{attrs:{"d":"M3 6h18v2H3V6m0 5h18v2H3v-2m0 5h18v2H3v-2z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }